function search(path, items, data) {
  items.forEach((item) => {
    if (item.path === path) {
      data.tags = item.tags ? [...item.tags, item.text] : [item.text];
    }
    if (item.items && !data.tags) {
      search(path, item.items, data);
    }
  });
}

export const breadcrumbsTranslations = (pathname, rawNavItems) => {
  const data = {};
  search(pathname, rawNavItems, data);
  if (!data.tags) return [];

  return data.tags;
};
